// Reusable US Letter (portrait) warehouse picking slip with hand-fill columns; mapped identity.
// Generated by scripts/wms/generate.ts for PHP-427. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomWarehousePickingSlipFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  customerBrandSubtitle: yup.string().nullable().optional(),
  waveId: yup.string().nullable().optional(),
  pickDeadline: yup.string().nullable().optional(),
  orderShipmentId: yup.string().nullable().optional(),
  tradingPartner: yup.string().nullable().optional(),
  shipTo: yup.string().nullable().optional(),
  packoutRule: yup.string().nullable().optional(),
  headerBarcode: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        lineNumber: yup.number().nullable().optional(),
        location: yup.string().nullable().optional(),
        sku: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        lot: yup.string().nullable().optional(),
        exp: yup.string().nullable().optional(),
        uom: yup.string().nullable().optional(),
        requiredQty: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomWarehousePickingSlipFileData = yup.InferType<
  typeof biomWarehousePickingSlipFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomWarehousePickingSlipFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomWarehousePickingSlipFileMappings: RequiredFileData = {
  customerDisplayName: '58ad48ad-1140-4f08-bb91-58f38f50f16d',
  customerBrandSubtitle: '71bc7054-23da-44fa-b101-1df879dcb540',
  waveId: 'd51fa321-7729-4371-bb33-81502fe9ad68',
  pickDeadline: '082079d0-d564-4f58-b5ed-e7d9442d545f',
  orderShipmentId: 'febef975-01a2-4ae7-a350-d358ef65f22f',
  tradingPartner: 'b5e04fa3-db5a-45ae-aa8a-6b2bc1871984',
  shipTo: 'b34a80e6-16df-4179-ad0a-810248e3086b',
  packoutRule: '5ea2e200-3f85-49a8-b4d1-566994cd19f1',
  headerBarcode: 'b8a05ce5-3b35-4bec-bad6-cccd1269bc12',
  items: [
    {
      lineNumber: null,
      location: '57df46b1-242f-47ab-945f-93ddd0bdd29c',
      sku: 'a668034e-bab2-4c96-a4ad-c127040c64de',
      description: '459dded6-5bfc-4ce0-a45a-27da12bedf65',
      lot: 'a39c8b7d-1bd6-488f-ba69-f60a5bc4b4fe',
      exp: 'b4c6e0f8-70e3-404e-bec8-c99a4e8bb7cb',
      uom: '91629511-c907-4f54-938a-f91c8108f9f1',
      requiredQty: 'c192e441-c29c-439b-b505-08ee83f56e96',
    },
  ],
}
